























import { defineComponent, PropType, ref } from "@vue/composition-api";
import { LiveChatInvitation } from "@scrile/api-provider/dist/api/LiveChatInvitationsProvider";
import AvatarDescription from "@/components/AvatarDescription";
import BaseButton from "@/components/BaseButton";
import ListItem from "@/components/ListItem";
export default defineComponent({
  name: "InvitationItem",
  components: { BaseButton, AvatarDescription, ListItem },
  props: {
    invitation: { type: Object as PropType<LiveChatInvitation>, required: true },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const cancelInvitation = () => {
      loading.value = true;
      emit("cancel", props.invitation.id, () => {
        loading.value = false;
      });
    };

    return { loading, cancelInvitation };
  },
});
